// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__r1+ms","logo":"Header_logo__UsziS","menuItem":"Header_menuItem__ZSIRW","active":"Header_active__rHuVo"};